/* eslint-disable no-unused-vars */
import '@preact/signals-react/auto';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/index.scss';
import './i18n/i18n';
import App from './App';
import { AppOldLogin } from './AppOldLogin';
import { AppGoogleLogin } from './AppGoogleLogin';
import reportWebVitals from './reportWebVitals';
import store from 'store/index';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from 'components/common/Theme';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { addRequestInterceptor, addResponseInterceptor } from '../src/axios/index';
import { accessTokenInterceptor } from '../src/axios/interceptors/accessToken.interceptor';
import { sessionRecoveryInterceptor } from './axios/interceptors/sessionRecovery.interceptor';
import { unkownErrorInterceptor } from './axios/interceptors/unkownError.interceptor';
import { initLinkValidatorAPI } from './services/linkValidatorAPI.service';

const root = ReactDOM.createRoot(document.getElementById('root'));
let persistor = persistStore(store);

// Initialize Link Validator API on window object
try {
  initLinkValidatorAPI(store);
} catch (e) {
  console.warn('LinkValidator API initialization failed:', e);
}

const basename1 = window.SUB_DOMAIN;

addRequestInterceptor(accessTokenInterceptor);
addResponseInterceptor(unkownErrorInterceptor);
addResponseInterceptor(sessionRecoveryInterceptor);

window.addEventListener('error', function (event) {
  if (event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    event.preventDefault();
    return true;
  }
  return false;
});

root.render(
  // <div>
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={basename1}>
          <ThemeProvider theme={theme}>
            {window.IS_GOOGLE_LOGIN ? <AppGoogleLogin /> : <AppOldLogin />}
          </ThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  // </div>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
